import React from 'react'
import {Popup, Cell, Button, Picker, Toast} from 'zarm'
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'
import {
  IconFont,
  ExamineTemplate, // 检查项
  AudioPlayer, // 音频
  MediaList, // 视频列表
  VideoPalyer,
  DataCompare, // 数据对比
} from '@wap/components'
import './index.less'

// 时间轴

class TimeLine extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {data = {}} = this.props
    const {list = []} = data
    return (
      <div className="timeline_content">
        <div className="time-con">
          {list.length ? list.map((item, index) => {
            const {
              examCode,
              examOdContent,
              examOsContent,
              examDate,
              examFiles = [],
              odAudioList = [],
              osAudioList = [],
              odVideoList = [],
              osVideoList = [],
            } = item
            // 过滤出图片数组
            const imageList = examFiles
              .filter((item) => item.fileType === 4)
              .map((item) => item.fileUrl)
            return (
              <div className="time-post">
                <div className="time-icon-con">
                  <div className="time-icon" />
                </div>
                <div className="time-content">
                  <div className="attendNodeTitle">
                    <div className="nodeName">
                      {moment(+examDate * 1000).format('YYYY-MM-DD')}
                    </div>
                  </div>
                  <div className="post_content">
                    {['od', 'os'].map((type, index_) => {
                      const key = `${index_ + 1}`
                      // 音频文件
                      const audioList = [odAudioList, osAudioList][index_] || []
                      // 视频文件
                      const videoList = [odVideoList, osVideoList][index_] || []
                      // 过滤出图片数组
                      const imageList = videoList
                        .filter((item) => item.fileType === 4)
                        .map((item) => item.fileUrl)
                      return (
                        <div key={key}>
                          <div className="content_main">
                            <div className={`icon_${['OD', 'OS'][index_]}`}>
                              {['OD', 'OS'][index_]}
                            </div>
                            <div className="content">
                              {[examOdContent, examOsContent][index_]}
                            </div>
                          </div>
                          {videoList.length > 0 && (
                            <MediaList>
                              {videoList.map((item_) => {
                                return (
                                  <VideoPalyer
                                    width={68}
                                    height={68}
                                    gutter={[4, 4]} // 上下左右间距
                                    key={item_.id}
                                    sourceURL={item_.sourceURL}
                                    sourceImage={item_.sourceImage}
                                    sourceList={imageList}
                                    showDelete={item_.showDelete} // 是否显示删除按钮
                                    onDelete={(e) =>
                                      this.onVideoDelete(item_.id)
                                    } // 删除事件
                                  />
                                )
                              })}
                            </MediaList>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          }) : 
          <div style={{ textAlign: 'center', margin: '20px 0' }}>暂无数据</div>}
        </div>
      </div>
    )
  }
}

export default TimeLine
